import composeInternalLinkURL from '@/utils/composeInternalLinkURL';
import { getSanitizedPageNumberAsURLParameter } from '../../utils';
import { type Nav } from '../PaginationItem';
import {
  StyledListItemNav,
  StyledNavLink,
  StyledNavLinkButton,
  StyledNavLinkIcon,
  StyledNavLinkTitle,
} from './PaginationItemNav.styles';

interface Props {
  item: Nav;
  urlBase: string;
  localization: {
    prev: string;
    next: string;
  };
}

const PaginationItemNav = ({ item, urlBase, localization }: Props) => {
  const { direction, isDisabled, page } = item;
  const linkURL = composeInternalLinkURL({
    urlChunks: [urlBase, getSanitizedPageNumberAsURLParameter(page)],
  });

  const navContent = (
    <>
      <StyledNavLinkIcon direction={direction} name="bx-arrow-back" />
      <StyledNavLinkTitle>{localization[direction]}</StyledNavLinkTitle>
    </>
  );

  if (!linkURL) {
    return null;
  }

  return (
    <StyledListItemNav navDirection={direction}>
      {isDisabled ? (
        <StyledNavLinkButton type="button" disabled>
          {navContent}
        </StyledNavLinkButton>
      ) : (
        <StyledNavLink to={linkURL}>{navContent}</StyledNavLink>
      )}
    </StyledListItemNav>
  );
};

export default PaginationItemNav;
